import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  AddOrUpdateKeywords,
  getCounties,
  getReportTypes,
  completeKeyword,
  searchMatches,
  getImage
} from "../../../WorkflowQueues/Keywords/redux-objects/actions";
import KeywordsForm, { IKeywordsFormProps } from "../presentation/KeywordsForm";
import {
  AgencyInfo,
  ErrorInfo,
  initialInvolvedParty,
  initialKeywordValues,
  initialErrorState,
  ReportTypesInfo,
  TypeInfo
} from "../business-objects/common";
import { getAllAgencies } from "../../../ThirdPartyVendors/redux-objects/actions";
import { updateHeaderByComponent } from "../../../Navigation/redux-objects/actions";
import * as urls from "../../../shared/urls";
import { UserInfo } from "../../../Login/common/defaults";
import moment from "moment";
import NotificationTemplateSelector from "../../../NotificationTemplate/NotificationTemplateSelector";
import * as optionIds from "../../../shared/optionIds";
import { getTableValuesByGroupName } from "../../../../services/Utils/IndexedDBUtils";
import { PromiseSerial } from "../../../../services/Utils/JSUtils";
import {
  Accordion,
  Card,
  Form,
  Row,
  Col,
  Button,
  Modal
} from "react-bootstrap";
import {
  IKeywords,
  IWorkflowItemStep,
  IReport,
  IAppRouteLocation
} from "../../../../common/sharedTypes";
import { b64toBlob } from "../../../PrintPDF/common/utils";
import { IPaperKeywordRequest } from "../../../WorkflowQueues/Keywords/business-objects/common";
import { KeywordMatchSearchResults } from "../presentation/KeywordMatchSearchResults";
import { toast } from "react-toastify";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import { updateKeywords } from "../../../WorkflowQueues/Management/redux-objects/actions";
import {
  REPORT_TYPE_BAC_ID,
  REPORT_TYPE_LETTERS_MEMOS_ID,
  REPORT_TYPE_OTHER_ID,
  REPORT_TYPE_PHOTOS_ID,
  REPORT_TYPE_SPD_ID
} from "../../../shared/constants";
import {
  handleInvolvedPartyChange,
  hasValue,
  validateAgency,
  validateDateOfCrash,
  validateNarrativeDiagram
} from "../common/utils";

interface IKeywordsControllerOwnProps {
  keywordData?: IKeywords;
  showNotificationTemplateSelector?: boolean;
  history: any;
}

interface IKeywordsControllerStateProps {
  webServiceURL: string;
  allAgencies: AgencyInfo[];
  typesByName: TypeInfo[];
  reportTypes: ReportTypesInfo[];
  currentUser: UserInfo;
  openWorkflowItemStep?: IWorkflowItemStep;
  hasSaved?: (assignNext: boolean) => void;
  reportMatches?: IReport[];
  openPaperReport?: (event: React.MouseEvent<HTMLElement>) => void;
  history: any;
  image: Uint8Array;
  splitCaseMode?: boolean;
  updateKeywords?: (keywords: IKeywords) => void;
}

interface IKeywordsControllerFromActions {
  getAllAgencies: (url: string) => Promise<void>;
  getReportTypes: (url: string) => Promise<void>;
  getCounties: (url: string) => Promise<void>;
  history: any;
  completeKeyword?: (
    url: string,
    request: IPaperKeywordRequest
  ) => Promise<IWorkflowItemStep>;
  updateHeaderByComponent: (newNav: string) => void;
  AddOrUpdateKeywords: (
    url: string,
    keywords: IKeywords,
    matchedReportId?: number,
    workflowItemStepId?: number
  ) => Promise<void>;
  searchMatches: (url: string, request: any) => Promise<IReport[]>;
  getImage: (keywordId: number, docuementId?: string) => Promise<void>;
}

interface IKeywordsControllerLocalState {
  keywords: IKeywords;
  editing: boolean;
  errors: ErrorInfo;
  counties: any[];
  exactDate: boolean;
  completeReportDisabled: boolean;
  matchedReportId?: number;
  history: any;
  exactNameMatch: boolean;
  completing: boolean;
}

type IKeywordsControllerProps = IKeywordsControllerOwnProps &
  IKeywordsControllerStateProps &
  IKeywordsControllerFromActions;

class KeywordsController extends React.Component<
  IKeywordsControllerProps,
  IKeywordsControllerLocalState
> {
  backgroundSave;
  saving: boolean;

  constructor(props: IKeywordsControllerProps) {
    super(props);
    this.state = {
      keywords: this.props.keywordData
        ? this.props.keywordData
        : initialKeywordValues,
      editing: false,
      errors: initialErrorState,
      counties: [],
      exactDate: false,
      completeReportDisabled: false,
      matchedReportId: null,
      history: "",
      exactNameMatch: false,
      completing: false
    };
  }

  componentDidMount() {
    this.loadData().then(() => {
      this.findMatches();
    });
    this.setButtonsDisabledOrEnabled();

    if (!this.backgroundSave) {
      this.backgroundSave = setInterval(() => {
        if (this.props.openWorkflowItemStep && !this.saving && !this.state.completing && !this.props.splitCaseMode) {
          this.handleKeywordSave(null, false);
        }
      }, 30000);
    }
  }

  componentWillUnmount(): void {
    clearInterval(this.backgroundSave);
  }

  setButtonsDisabledOrEnabled() {
    const reportType = this.state.keywords.reportTypeId;
    if (reportType == 4 || this.state.matchedReportId)
      this.setState({ completeReportDisabled: false });
    else {
      this.setState({ completeReportDisabled: true });
    }
  }

  loadData = () => {
    return new Promise<void>((resolve) => {
      const { allAgencies, webServiceURL, reportTypes, currentUser } =
        this.props;
      const { counties } = this.state;
      PromiseSerial([
        () => {
          return new Promise<void>((resolve) => {
            if (allAgencies.length === 0) {
              this.props
                .getAllAgencies(`${webServiceURL}${urls.GET_ALL_AGENCIES}`)
                .then((result) => resolve());
            } else {
              resolve();
            }
          });
        },
        () => {
          return new Promise<void>((resolve) => {
            if (counties.length === 0) {
              getTableValuesByGroupName("County").then((results) => {
                this.setState({ counties: results });
                resolve();
              });
            } else {
              resolve();
            }
          });
        },
        () => {
          return new Promise<void>((resolve) => {
            if (reportTypes.length === 0) {
              this.props
                .getReportTypes(`${webServiceURL}${urls.GET_ALL_REPORT_TYPES}`)
                .then((result) => resolve());
            } else {
              resolve();
            }
          });
        },
        () => {
          return new Promise<void>((resolve) => {
            if (
              this.props.openWorkflowItemStep &&
              this.props.openWorkflowItemStep.workflowItem &&
              this.props.openWorkflowItemStep.workflowItem.reportId > 0
            ) {
              this.props
                .getImage(
                  this.props.openWorkflowItemStep.workflowItem.reportId,
                  this.props.keywordData.documentId
                )
                .finally(() => resolve());
            } else {
              resolve();
            }
          });
        }
      ]).then((retun) => resolve());
    });
  };

  getMaxVal = (data) => {
    return data.reduce((max, p) => (p.id > max ? p.id : max), data[0].id);
  };

  handleInvolvedPartyChange = (event) => {
    const { keywords } = this.state;
    const newParties = handleInvolvedPartyChange(event, keywords);

    this.setState((state) => ({
      keywords: {
        ...state.keywords,
        involvedParties: newParties
      }
    }));
  };

  determineValueToUse = (name, value) => {
    const { reportTypes, allAgencies } = this.props;
    switch (name) {
      case "reportTypeId":
        // const reportType = parseInt(value);
        // this.setButtonsDisabledOrEnabled();
        return value;
      case "agencyId":
        return value;
      default:
        return value;
    }
  };

  hanldeInvolvedPartyBlur = (event) => {
    this.findMatches();

    if (this.props.splitCaseMode) {
      this.props.updateKeywords(this.state.keywords);
    }
  };
  handleChange = (event) => {
    const { name, value, type } = event.target;
    if (type !== "manual") {
      event.preventDefault();
    }

    const { keywords } = this.state;

    const valueToUse = this.determineValueToUse(name, value);

    this.setState(
      (prevState) => ({
        keywords: {
          ...prevState.keywords,
          [name]: valueToUse
        },
        editing: true
      }),
      () => {
        switch (name) {
          case "reportTypeId":
            this.setButtonsDisabledOrEnabled();
          case "countyId":
            this.validateCountySelection();
            this.findMatches();
          case "injuryStatus":
            this.validateInjurySelection();
          case "agencyId":
            this.validateAgencySelection();
          case "narrativeDiagramPages":
            this.validateNarrativeDiagram();
        }
        if (this.props.splitCaseMode) {
          this.props.updateKeywords(this.state.keywords);
        }
        return true;
      }
    );
  };

  handleMatchChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case "exactDate":
        this.setState(
          {
            exactDate: el.checked
          },
          () => {
            this.findMatches();
          }
        );
        break;
      case "exactNameMatch":
        this.setState(
          {
            exactNameMatch: el.checked
          },
          () => {
            this.findMatches();
          }
        );
        break;
      default:
        break;
    }
  };

  handleDateChange = (date: Date) => {
    this.setState(
      (prevState) => ({
        keywords: {
          ...prevState.keywords,
          dateOfCrash: date?.toDateString()
        },
        editing: true
      }),
      () => {
        if (this.props.splitCaseMode) {
          this.props.updateKeywords(this.state.keywords);
        }
        this.validateDateOfCrash();
        this.findMatches();
      }
    );
  };

  handleKeywordSave = (event, redirectToQueue: boolean) => {
    event?.preventDefault();

    this.saving = true;

    const { keywords, matchedReportId } = this.state;
    const { webServiceURL } = this.props;

    const validated = this.validateFields();
    if (validated) {
      this.props
        .AddOrUpdateKeywords(
          `${webServiceURL}${urls.SAVE_KEYWORDS}`,
          keywords,
          matchedReportId,
          this.props.openWorkflowItemStep?.id ?? 0
        )
        .then((result) => {
          if (redirectToQueue)
            this.props.history.push("/KeywordQueue");
        });
    }
    this.saving = false;
  };

  handleComplete(event: React.MouseEvent<HTMLElement>, assignNext: boolean) {
    const reportType = this.state.keywords.reportTypeId;
    if (
      this.state.matchedReportId == null &&
      (reportType == REPORT_TYPE_BAC_ID ||
        reportType == REPORT_TYPE_LETTERS_MEMOS_ID ||
        reportType == REPORT_TYPE_OTHER_ID ||
        reportType == REPORT_TYPE_PHOTOS_ID ||
        reportType == REPORT_TYPE_SPD_ID)
    ) {
      toast.info(
        "You cannot complete the report without first selecting a matched report"
      );
      this.setButtonsDisabledOrEnabled();
      return;
    } else {
      const validated = this.validateFields();
      if (validated) {
        this.setState({ completeReportDisabled: true, completing: true });
        this.props
          .completeKeyword(
            this.props.webServiceURL + urls.COMPLETE_PAPER_KEYWORDS,
            {
              workflowItemStepId: this.props.openWorkflowItemStep?.id ?? 0,
              assignNext: assignNext,
              assignTo: this.props.openWorkflowItemStep?.assignedTo ?? 0,
              keywords: this.state.keywords,
              matchedReportId: this.state.matchedReportId
            } as IPaperKeywordRequest
          )
          .then((response: any) => {
            if(response.ClassName == "System.Exception")
              {
                this.setState({completing: false, completeReportDisabled: false});
                toast.error(response.Message);
                console.debug("complete keywords error", response);
                return;
              }
            else if (assignNext) {
              this.setState(
                {
                  keywords: response.workflowItem.report.keywords
                },
                () => this.resetKeywordsForm()
              );
            }
            else {
              this.props.hasSaved(assignNext);
            }
          })
          .catch(() => this.setState({completing: false, completeReportDisabled: false}))
          .finally(() => this.setState({ completeReportDisabled: false }))
      }
    }
  }

  findMatches = () => {
    if (this.props.splitCaseMode) {
      return;
    }
    try {
      var request = {
        involvedParties: this.state.keywords.involvedParties,
        dateOfCrash: this.state.keywords.dateOfCrash,
        countyId: this.state.keywords.countyId,
        exactDate: this.state.exactDate,
        doFuzzyNameSearch: !this.state.exactNameMatch
      };
      //console.log('searching matches on', request);
      this.props.searchMatches(urls.SEARCH_KEYWORD_MATCHES, request);
    } catch (e) {
      console.log("error searching matches", e);
    }
  };

  sendToManagementQueue = () => {
    try {
      Api.post(urls.SEND_TO_MANAGEMENT_QUEUE, {
        workflowItemStepId: this.props.openWorkflowItemStep?.id ?? 0
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          let location: IAppRouteLocation = {
            pathname: "/KeywordQueue"
          };
          this.props.history.push(location);
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  resetKeywordsForm = () => {
    this.setState({
      //keywords: initialKeywordValues,
      editing: false,
      errors: initialErrorState
    });
  };

  validateDateOfCrash = () => {
    const { keywords } = this.state;
    const hasValidDateOfCrash = validateDateOfCrash(
      keywords.dateOfCrash as string
    );
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        crashDate: hasValidDateOfCrash.message
      }
    }));
    return hasValidDateOfCrash.isValid;
  };

  validateCountySelection = () => {
    const { keywords } = this.state;
    const hasValidCounty = hasValue(keywords.countyId);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        countySelection: !hasValidCounty
          ? "A valid county selection is required!"
          : ""
      }
    }));

    return hasValidCounty;
  };

  validateAgencySelection = () => {
    const { keywords } = this.state;
    const hasValidAgency = validateAgency(keywords);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        agencySelection: !hasValidAgency
          ? "A valid agency selection is required!"
          : ""
      }
    }));

    return hasValidAgency;
  };

  validateNarrativeDiagram = () => {
    const { keywords } = this.state;
    const hasValidNarrativeDiagram = validateNarrativeDiagram(keywords);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        narrativeDiagram: !hasValidNarrativeDiagram
          ? "Must specify narrative and diagram pages for Investigator Report!"
          : ""
      }
    }));

    return hasValidNarrativeDiagram;
  };

  validateInjurySelection = () => {
    const { keywords, editing } = this.state;
    const hasValidInjury = keywords.injuryStatus ? true : false;

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        injurySelection: !hasValidInjury ? "A valid injury is required!" : ""
      }
    }));

    return hasValidInjury;
  };

  validateInvolvedParties = () => {
    const { keywords, editing } = this.state;
    const hasValidInvolvedParties =
      keywords &&
        keywords.involvedParties.length > 0 &&
        ((keywords.involvedParties[0].firstName !== "" &&
          keywords.involvedParties[0].lastName !== "") ||
          keywords.involvedParties[0].businessName !== "")
        ? true
        : false;

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        involvedPartyLength: !hasValidInvolvedParties
          ? "One involved party is required!"
          : ""
      }
    })),
      () => {
        return true;
      };
    return hasValidInvolvedParties;
  };

  validateFields = () => {
    const hasValidDateOfCrash = this.validateDateOfCrash();
    const hasValidCounty = this.validateCountySelection();
    const hasValidInjury = this.validateInjurySelection();
    const hasValidInvolvedParty = this.validateInvolvedParties();
    const hasValidAgency = this.validateAgencySelection();
    const hasValidNarrativeDiagram = this.validateNarrativeDiagram();

    const validated =
      hasValidDateOfCrash &&
      hasValidCounty &&
      hasValidInjury &&
      hasValidAgency &&
      hasValidInvolvedParty &&
      hasValidNarrativeDiagram;

    return validated;
  };

  handleErrors = (errors) => {
    this.setState({ errors: errors });
  };

  getData = () => {
    return this.state.keywords;
  };

  matchSelected = (copyReport: IReport) => {
    let keywords = this.state.keywords;
    keywords.countyId = copyReport.keywords.countyId;
    keywords.reportTypeId = copyReport.keywords.reportTypeId;
    keywords.agencyId = copyReport.keywords.agencyId;
    keywords.propertyDamageIndicator =
      copyReport.keywords.propertyDamageIndicator;
    keywords.workZoneIndicator = copyReport.keywords.workZoneIndicator;
    keywords.injuryStatus = copyReport.keywords.injuryStatus;
    keywords.truckBusIndicator = copyReport.keywords.truckBusIndicator;
    keywords.nonMotoristIndicator = copyReport.keywords.nonMotoristIndicator;
    keywords.involvedParties = copyReport.keywords.involvedParties.map(
      (x, index) => {
        const i = index * -1;
        const businessOwned =
          x.businessName && x.businessName.length > 0 ? true : false;
        return { ...x, businessOwned, id: i };
      }
    );

    this.setState({ completeReportDisabled: false });
    this.setState({ matchedReportId: copyReport.id });
    this.setState({ keywords }, () => {
      this.validateFields();
    });
  };

  render() {
    const { keywords, errors, counties } = this.state;
    const { allAgencies, reportTypes } = this.props;

    const agencies = allAgencies.length > 0 ? allAgencies : [];

    const keywordsProps: IKeywordsFormProps = {
      keywords,
      agencies,
      counties,
      reportTypes,
      errors,
      showNotificationTemplateSelector:
        this.props.showNotificationTemplateSelector,
      onInvolvedPartyChange: this.handleInvolvedPartyChange,
      onChange: this.handleChange,
      onDateChange: this.handleDateChange,
      onInvolvedPartyBlur: this.hanldeInvolvedPartyBlur,
      reportId: this.props.openWorkflowItemStep?.workflowItem?.reportId ?? 0,
      image: this.props.image,
      splitCaseMode: this.props.splitCaseMode
    };

    const stepOne = keywordsProps.agencies && (
      <KeywordsForm {...keywordsProps} />
    );

    const componentReady = agencies && counties && reportTypes;
    return (
      <React.Fragment>
        {componentReady && (
          <React.Fragment>
            {keywordsProps.agencies && keywordsProps.counties && stepOne}
          </React.Fragment>
        )}
        <br />
        <br /> <br />
        <Form>
          <Row>
            {!this.props.splitCaseMode && (
              <React.Fragment>
                <Col sm="3">
                  <Button
                    size="sm"
                    onClick={(e) => this.handleKeywordSave(e, true)}
                    variant="success"
                    className="mt-10"
                  >
                    Save
                  </Button>
                  {"    "}
                  <Button
                    variant="success"
                    size="sm"
                    disabled={this.state.completeReportDisabled}
                    onClick={(e) => this.handleComplete(e, true)}
                    className="mt-10"
                  >
                    Complete and Start Next
                  </Button>
                  {"    "}
                  <Button
                    variant="success"
                    size="sm"
                    disabled={this.state.completeReportDisabled}
                    onClick={(e) => this.handleComplete(e, false)}
                    className="mt-10"
                  >
                    Complete
                  </Button>
                  <br />
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={(e) => this.props.openPaperReport(e)}
                    className="mt-10"
                  >
                    Re-Open PDF
                  </Button>
                  {"    "}
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={(e) => this.findMatches()}
                    className="mt-10"
                  >
                    Find Matches
                  </Button>
                  {"    "}
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => this.sendToManagementQueue()}
                    className="mt-10"
                  >
                    Send to Admin
                  </Button>
                </Col>
                <Col sm="9">
                  <Accordion
                    activeKey={
                      this.props.reportMatches &&
                        this.props.reportMatches.length > 0
                        ? "matchResults"
                        : "0"
                    }
                  >
                    <Card key="matchResults" className="">
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey="matchResults"
                        key="matchResults"
                        className="accordianHeader"
                      >
                        {this.props.reportMatches && (
                          <Form.Row>
                            <Form.Group as={Col}>
                              <h3>
                                {this.props.reportMatches.length == 0
                                  ? "No Matches"
                                  : this.props.reportMatches.length == 1
                                    ? "1 Match"
                                    : this.props.reportMatches.length +
                                    " Matches"}
                              </h3>
                            </Form.Group>
                            <Form.Group as={Col} controlId="chknExperian">
                              <Form.Check
                                type="checkbox"
                                data-field="exactDate"
                                label=" Exact Date match"
                                checked={this.state.exactDate}
                                onChange={this.handleMatchChange}
                              />
                            </Form.Group>
                            <Form.Group as={Col} controlId="chkExactNameMatch">
                              <Form.Check
                                type="checkbox"
                                data-field="exactNameMatch"
                                label="Exact Name Match"
                                checked={this.state.exactNameMatch}
                                onChange={this.handleMatchChange}
                              />
                            </Form.Group>
                          </Form.Row>
                        )}
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="matchResults">
                        <Card.Body>
                          <KeywordMatchSearchResults
                            matchResults={this.props.reportMatches}
                            onChangeKeywordMatchSearchResults={(rd) =>
                              this.matchSelected(rd)
                            }
                          />
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </Col>
              </React.Fragment>
            )}
          </Row>
        </Form>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(redux: any) {
  return {
    webServiceURL: redux.Application.backendURL,
    allAgencies: redux.Vendors.allAgencies,
    typesByName: redux.LookupTypes.typesByName,
    counties: redux.Keywords.counties,
    reportTypes: redux.Keywords.reportTypes,
    currentUser: redux.Application.currentUser,
    openWorkflowItemStep: redux.Keywords.openWorkflowItemStep,
    reportMatches: redux.Keywords.reportMatches,
    image: redux.Keywords.image
  };
}

const mapDispatchToProps = {
  AddOrUpdateKeywords,
  getAllAgencies,
  updateHeaderByComponent,
  getCounties,
  getReportTypes,
  completeKeyword,
  searchMatches,
  getImage,
  updateKeywords
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(KeywordsController)
);
